import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  private notificationSound: HTMLAudioElement;

  constructor() {
    // Create audio element for notification sound
    this.notificationSound = new Audio('assets/sounds/notification.mp3');
    this.notificationSound.volume = 0.5; // Set volume to 50%
  }

  /**
   * Plays the notification sound
   */
  public playNotification(): void {
    // Reset the audio to start if it was already playing
    this.notificationSound.currentTime = 0;
    this.notificationSound.play().catch((error) => {
      console.error('Error playing notification sound:', error);
    });
  }
}
